module.exports = __webpack_public_path__ + "img/login-car-v2-Abcn.a20e0da9.svg";